<template>
  <router-link :to="{ name: 'profile' }">
    <img
      src="@/assets/images/logo/logo-c-white.png"
      alt=""
      v-if="themeSettingsStore.isDark"
    />
  </router-link>
</template>
<script>
import {useThemeSettingsStore} from "@/stores/themeSettings.js";
export default {
  setup() {
    const themeSettingsStore = useThemeSettingsStore();
    return {
      themeSettingsStore
    }
  }
};
</script>
